import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import styles from './styles.js';

class ListItemRow extends React.Component {
  render() {
    const {
      classes,
      isHeader,
      primaryLabel,
      secondaryLabel,
      primaryValue,
      primaryValueAction,
      hidePrimaryValueMobile,
    } = this.props;

    let hasHelp = primaryValueAction;

    let value;
    hasHelp
      ? (value = (
          <span>
            {primaryValueAction} {primaryValue}
          </span>
        ))
      : (value = primaryValue);

    let balance = value && (
      <Grid item xs={6} className={`${classes.gridItemRight} GridItemRight`}>
        {typeof primaryValue == 'string' ? (
          <Typography className={classes.primaryText}>{value}</Typography>
        ) : (
          value
        )}
      </Grid>
    );

    if (hidePrimaryValueMobile) {
      balance = <Hidden xsDown>{balance}</Hidden>;
    }

    return (
      <div className={classes.root}>
        <ListItem
          className={isHeader ? classes.listItemHeader : classes.listItem}
          component='div'
        >
          <Grid
            container
            className={
              isHeader ? classes.gridContainerHeader : classes.gridContainer
            }
          >
            <Grid
              item
              xs={value ? 6 : 12}
              className={`${classes.gridItemLeft} GridItemLeft`}
            >
              <ListItemText
                primary={primaryLabel}
                secondary={secondaryLabel}
                className={classes.listItemText}
                classes={{
                  primary: classes.primaryLabel,
                  secondary: classes.secondaryLabel,
                }}
                disableTypography={isHeader ? true : false}
              />
            </Grid>
            {balance}
          </Grid>
        </ListItem>
      </div>
    );
  }
}

ListItemRow.propTypes = {
  classes: PropTypes.object.isRequired,
  isHeader: PropTypes.bool,
  primaryLabel: PropTypes.string.isRequired,
  secondaryLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  primaryValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hidePrimaryValueMobile: PropTypes.bool,
};

ListItemRow.defaultProps = {
  isHeader: false,
  hidePrimaryValueMobile: false,
};

export default withStyles(styles)(ListItemRow);
